/** @fileoverview Line-art illustration for the "App not found" view. */

/** Draws an empty app window with a magnifying glass over its corner. */
export default function AppNotFoundIllustration() {
  return (
    <svg
      viewBox="0 0 200 150"
      className="w-44 max-w-full"
      fill="none"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <circle cx="100" cy="75" r="64" className="fill-muted" opacity="0.6" />
      <g className="text-app-text-muted" stroke="currentColor">
        <rect x="38" y="28" width="108" height="80" rx="8" className="fill-background" />
        <path d="M38 46h108" />
        <circle cx="49" cy="37" r="1.5" fill="currentColor" />
        <circle cx="57" cy="37" r="1.5" fill="currentColor" />
        <circle cx="65" cy="37" r="1.5" fill="currentColor" />
        <g strokeDasharray="4 5" opacity="0.7">
          <path d="M52 62h62" />
          <path d="M52 74h46" />
          <path d="M52 86h30" />
        </g>
      </g>
      <g className="text-primary" stroke="currentColor">
        <circle cx="138" cy="96" r="21" className="fill-background" />
        <path d="M153 111l16 16" strokeWidth={4} />
        <path d="M132 90c0-4 3-6.5 6-6.5s6 2.2 6 5.5c0 4-6 4.5-6 9" />
        <circle cx="138" cy="106" r="1.2" fill="currentColor" />
      </g>
    </svg>
  );
}
